// 内联色文字 / 徽章：浅色保持原色；深色模式由 index.css 的 `.dark [style*="--ink"]` 规则自动提亮（带底色时底色改为半透明深底）
export const ink = (color, bg) => {
  if (!color) return undefined;
  if (!bg) return { "--ink": color, color };
  return { "--ink": color, "--tint": 1, color, background: bg === true ? `${color}12` : bg };
};
